import React from 'react'
import UserProfileModel from '../models/user-models/UserProfileModel'
import { FirebaseService, FirebaseConfigKey } from './FirebaseService'
import { InsuranceBillingPeriod } from '../models/insurance-models/InsuranceBillingPeriodModel'
import { liabilityLimitPretty, getTotalHullValue, isUK } from './utils'
import { COUNTRIES } from '../Constants'
import { SessionService } from './SessionService'
import BrokerConfigService from './BrokerConfigService'

class ViolationsService {
    isUserProfileOK(userProfile: UserProfileModel) {
        return (
            userProfile.firstName &&
            userProfile.lastName &&
            userProfile.address1
        )
    }

    isCreditCardOK(userProfile) {
        return userProfile.hasCreditCard
    }

    checkOperatorsViolations(operators: any[]) {
        return (
            FirebaseService.getValue(FirebaseConfigKey.COUNTRY) ==
                COUNTRIES.US ||
            FirebaseService.getValue(FirebaseConfigKey.COUNTRY) ==
                COUNTRIES.CANADA ||
            (FirebaseService.getValue(FirebaseConfigKey.COUNTRY) ==
                COUNTRIES.UK &&
                operators.length > 0)
        )
    }

    checkHullViolations(
        insurance: InsuranceOptionModel,
        drones = [],
        equipment = []
    ) {
        // If its a voom broker, allow everything..
        if (SessionService.isAdmin())
            return { msg: '', error: false, can_buy_insurance: true }

        let hullIncluded =
            insurance.dronePremium > 0 ||
            insurance.equipmentPremium > 0 ||
            drones.length > 0 ||
            equipment.length > 0
        let color = hullIncluded ? 'red' : 'grey'
        // Check insurance types (Monthly)
        if (
            insurance.billingPeriod == InsuranceBillingPeriod.MONTH &&
            !FirebaseService.getValue(
                FirebaseConfigKey.HULL_INSURANCE_AVAILABLE_FOR_MONTHLY
            ) &&
            hullIncluded
        ) {
            let result = { error: true, can_buy_insurance: !hullIncluded }
            if (
                FirebaseService.getValue(
                    FirebaseConfigKey.HULL_INSURANCE_AVAILABLE_FOR_ANNUAL
                )
            )
                result.msg = hullIncluded ? (
                    <div className={`text-body ${color}`}>
                        Hull insurance is available through our{' '}
                        <a
                            href={`/insurance/annual${document.location.search}`}
                            className="blue clickable underline"
                        >
                            annual plan
                        </a>
                    </div>
                ) : (
                    <div className={`text-body ${color}`}>
                        Hull insurance is available through our{' '}
                        <a
                            href={`/insurance/annual${document.location.search}`}
                            className="blue clickable underline"
                        >
                            annual plan
                        </a>
                    </div>
                )
            else
                result.msg = (
                    <div className={`text-body ${color}`}>
                        Hull insurance is not available
                    </div>
                )
            return result
        }

        // Check insurance types (Yearly)
        if (
            insurance.billingPeriod == InsuranceBillingPeriod.YEAR &&
            !FirebaseService.getValue(
                FirebaseConfigKey.HULL_INSURANCE_AVAILABLE_FOR_ANNUAL
            ) &&
            hullIncluded
        ) {
            let result = { error: true, can_buy_insurance: !hullIncluded }
            if (
                FirebaseService.getValue(
                    FirebaseConfigKey.HULL_INSURANCE_AVAILABLE_FOR_MONTHLY
                )
            )
                result.msg = hullIncluded ? (
                    <div className={`text-body ${color}`}>
                        Hull coverage is not available when on an annual plan
                    </div>
                ) : (
                    <div className={`text-body ${color}`}>
                        Hull insurance is available through our{' '}
                        <a
                            href={`/insurance/monthly${document.location.search}`}
                            className="blue clickable underline"
                        >
                            monthly plan
                        </a>
                    </div>
                )
            else
                result.msg = (
                    <div className={`text-body ${color}`}>
                        Hull insurance is not available
                    </div>
                )
            return result
        }

        // Checks Liability limit
        if (
            hullIncluded &&
            insurance.liabilityLimit <
                FirebaseService.getValue(
                    FirebaseConfigKey.HULL_LIABILITY_MINIMUM
                ) &&
            BrokerConfigService.getCurrenctThemedSite() != 'magnesgroup' &&
            (FirebaseService.getValue(
                FirebaseConfigKey.HULL_INSURANCE_AVAILABLE_FOR_MONTHLY
            ) ||
                FirebaseService.getValue(
                    FirebaseConfigKey.HULL_INSURANCE_AVAILABLE_FOR_ANNUAL
                ))
        ) {
            let msg = hullIncluded ? (
                <div className={`text-body ${color}`}>
                    Hull Insurance can be added to policies with a liability
                    limit of{' '}
                    {liabilityLimitPretty(
                        FirebaseService.getValue(
                            FirebaseConfigKey.HULL_LIABILITY_MINIMUM
                        )
                    )}{' '}
                    and above
                </div>
            ) : (
                <div className={`text-body ${color}`}>
                    Hull Insurance is available from{' '}
                    {liabilityLimitPretty(
                        FirebaseService.getValue(
                            FirebaseConfigKey.HULL_LIABILITY_MINIMUM
                        )
                    )}{' '}
                    liability limit
                </div>
            )
            return { msg: msg, error: true, can_buy_insurance: !hullIncluded }
        }

        if (drones.length == 0 && equipment.length > 0) {
            return {
                msg: (
                    <div className="text-body red">
                        To cover equipment you must have at least 1 drone
                    </div>
                ),
                error: true,
                can_buy_insurance: false,
            }
        }

        if (drones.length == 0 && isUK()) {
            return {
                msg: (
                    <div className="text-body red">
                        At least one drone should be added
                    </div>
                ),
                error: true,
                can_buy_insurance: false,
            }
        }

        if (
            FirebaseService.getValue(
                FirebaseConfigKey.TOTAL_HULL_SUM_INSURED
            ) &&
            getTotalHullValue(drones, equipment) >
                FirebaseService.getValue(
                    FirebaseConfigKey.TOTAL_HULL_SUM_INSURED
                )
        ) {
            return {
                msg: (
                    <div className="text-body red">
                        Total hull value is limited to{' '}
                        {FirebaseService.getValue(
                            FirebaseConfigKey.CURRENCY_SYMBOL
                        )}
                        {FirebaseService.getValue(
                            FirebaseConfigKey.TOTAL_HULL_SUM_INSURED
                        ).toLocaleString()}
                    </div>
                ),
                error: true,
                can_buy_insurance: false,
            }
        }
        return { msg: '', error: false, can_buy_insurance: true }
    }
}

export default new ViolationsService()
